import { on as onEvent } from "common/utils/ui/event";
import "./component.scss";

const CLASS_NAMES = {
  SECTION_LINK: ".mobile-menu__section",
  MOBILE: {
    SLIDE: ".js-masthead-drinkware-slide",
    SLIDE_LINK: ".js-masthead-drinkware-slide-link",
    EXPANDED_SLIDE: "masthead-drinkware-navigation__slide--expanded",
    BACK: '.js-mobile-submenu-trigger[data-category="Drinkware"]'
  }
};

const $getContainer = () => document.querySelector(".js-masthead-drinkware-navigation");
const $getSlides = () => document.querySelectorAll(CLASS_NAMES.MOBILE.SLIDE);

export default function initMobileNavigation() {
  onEvent("click", CLASS_NAMES.MOBILE.SLIDE_LINK, event => {
    const $slide = event.target.closest(CLASS_NAMES.MOBILE.SLIDE);
    event.preventDefault();

    if ($slide) {
      $slide.classList.toggle(CLASS_NAMES.MOBILE.EXPANDED_SLIDE);

      const $container = $getContainer();
      const $section = $container?.closest(CLASS_NAMES.SECTION_LINK);

      if ($container && $section) {
        const { height } = $container.getBoundingClientRect();
        const extendedSlides = Array.from($getSlides()).some($el =>
          $el.classList.contains(CLASS_NAMES.MOBILE.EXPANDED_SLIDE)
        );
        const minHeight = extendedSlides ? height : 0;
        $section.style.minHeight = `${minHeight}px`;
      }
    }
  });

  onEvent("click", CLASS_NAMES.MOBILE.BACK, event => {
    const $section = event.target.closest(CLASS_NAMES.SECTION_LINK);

    if ($section) {
      $section.style.minHeight = "0";
    }

    $getSlides().forEach($slide => {
      $slide.classList.remove(CLASS_NAMES.MOBILE.EXPANDED_SLIDE);
    });
  });
}
